import { defaultCss } from 'survey-core'
import './coorum-override.css'

// TODO: 後でいいやり方を考える
function merge(left: Record<string, any>, right: Record<string, any>) {
  for (const key in left) {
    const value = left[key]
    if (value && typeof value === 'object' && right[key] && typeof right[key] === 'object') {
      merge(value, right[key])
    } else if (value && typeof value === 'string' && right[key] && typeof right[key] === 'string') {
      left[key] = `${value} ${right[key]}`
    } else {
      left[key] = value
    }
  }

  return left
}

// SurveyJSライブラリが描画するDOMに追加するカスタムCSS
const additionalClasses = {
  rootWrapper: 'h-full [&>form]:h-full overflow-y-hidden',
  container: 'h-full',
  bodyContainer: 'h-full',
  bodyNavigationButton: 'text-[--sjs-general-forecolor] !py-2 !shadow-none hover:brightness-95',
  footer: '!p-6',
  progressButtonsConnector: '!hidden',
  progressButtonsButton: '!hidden',
  progressButtonsFooter: 'hidden',
  progressButtonsList: 'rounded-[4px] bg-[--sjs-secondary-backcolor] h-2 [&>li]:!grow [&>li]:cursor-pointer overflow-hidden [&>.progressButtonsListElementPassed:has(~.progressButtonsListElementCurrent)]:bg-[--sjs-primary-backcolor]',
  progressButtonsListElementPassed: 'progressButtonsListElementPassed',
  progressButtonsListElementCurrent: 'progressButtonsListElementCurrent bg-[--sjs-primary-backcolor] rounded-r-[4px]',
  navigation: {
    complete: 'bg-[--sjs-primary-backcolor] hover:brightness-95 hover:text-[--sjs-general-forecolor]',
    prev: '!bg-white border border-solid border-[--sjs-general-forecolor] hover:!bg-accent',
  },
  page: {
    root: '!px-6 h-full overflow-y-auto',
  },
  pageRow: '',
  question: {
    titleTopRoot: 'h-full space-y-2',
    content: 'h-full pr-[2px] pl-[2px] pb-[2px] !mt-0',
    title: '[&_span]:!text-xl pb-2',
    headerTop: 'pb-0 sticky top-0 bg-white z-10 mb-2',
  },
  checkbox: {
    root: 'mt-[-4px]',
    controlLabel: 'break-all',
  },
  radiogroup: {
    root: 'mt-[-4px]',
    controlLabel: 'break-all',
  },
  boolean: {
    root: 'pt-[4px]',
    radioControlLabel: 'break-all',
    checkboxControlLabel: 'break-all',
  },
  rating: {
    root: '!w-full [&>fieldset]:flex [&>fieldset]:gap-4 [&>fieldset]:justify-center',
  },
  file: {
    fileDecorator: 'rounded-[4px] bg-[--sjs-secondary-backcolor]',
    dragAreaPlaceholder: 'text-[--sjs-general-forecolor]',
    chooseFile: 'bg-[--sjs-general-backcolor] text-[--sjs-general-forecolor] rounded-[4px] border border-solid border-[--sjs-general-forecolor] hover:!bg-accent',
    chooseFileAsText: '[&>svg]:!fill-[--sjs-general-forecolor]',
    actionsContainer: 'mt-4 flex gap-4',
    imageWrapper: '!bg-[--sjs-secondary-backcolor]',
  },
  imagepicker: {
    root: 'grid grid-cols-2 auto-cols-auto gap-2',
    imageContainer: 'border rounded-[6px] overflow-hidden',
    image: 'rounded-none',
  },
  actionBar: {
    item: 'bg-[--sjs-general-backcolor] text-[--sjs-general-forecolor] rounded-[4px] border border-solid border-[--sjs-general-forecolor] hover:!bg-accent',
    itemIcon: '[&>use]:!fill-[--sjs-general-forecolor]',
  },
  dropdown: {
    popup: 'w-full min-w-0 max-w-full left-0',
  },
}

const coorumCss = merge(JSON.parse(JSON.stringify(defaultCss)), additionalClasses)

// 上書き
coorumCss.body = '!p-0 h-full sd-body' // bodyにはCSSを拡張する処理がある @see https://github.com/surveyjs/survey-library/blob/0963b5d09b1dcd50bb69f2ad7dd594754a4e642c/src/survey.ts#L1195
coorumCss.progressButtonsRoot = '!p-6 sd-progress-buttonsh' // progressButtonsRootにはCSSを拡張する処理がある @see https://github.com/surveyjs/survey-library/blob/eeabdc856075203ab7f47c71d56a0d38303bba3a/src/progress-buttons.ts#L21

export { coorumCss }
